/**
 * Encodes an image file to base64 format.
 * @param imageFile - The image file to be encoded.
 * @returns A promise that resolves to the encoded file as a base64 string.
 */
export async function encodeImageToBase64(imageFile: Blob) {
  const encodedFileAsBase64 = await new Promise<string>((resolve) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result as string)
    reader.readAsDataURL(imageFile)
  })
  return encodedFileAsBase64
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function convertirPDFaBase64(
  file: $TSMigrationFixMe
): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onload = () => {
      const base64String = (reader.result as string).split(",")[1] // Obtiene la parte Base64
      resolve(base64String)
    }

    reader.onerror = (error) => {
      reject(error)
    }

    reader.readAsDataURL(file)
  })
}
